<ng-container *transloco="let t">

  <div>
    <ng-container *ngIf="code$ | async as code">
      <button mat-flat-button type="button" color="accent" class="mr-1" (click)="viewCode(javascriptTmpl, code)">
        <mat-icon>visibility</mat-icon>
        {{t('write-data-report.viewCode')}}
      </button>
    </ng-container>

    <ng-container *ngIf="result$ | async as result">
      <button mat-flat-button type="button" color="accent" (click)="viewResult(jsonTmpl, result)">
        <mat-icon>visibility</mat-icon>
        {{t('write-data-report.viewResult')}}
      </button>
    </ng-container>

    <ng-template #jsonTmpl>
      <form [formGroup]="resultForm">
        <ngx-monaco-editor class="editor" [options]="jsonEditorOptions" formControlName="value">
        </ngx-monaco-editor>
      </form>
    </ng-template>

    <ng-template #javascriptTmpl>
      <form [formGroup]="codeForm">
        <ngx-monaco-editor class="editor" [options]="javascriptEditorOptions" formControlName="value">
        </ngx-monaco-editor>
      </form>
    </ng-template>
  </div>
</ng-container>
